import React from 'react';
import ReactDOM from 'react-dom';
import SignupContainer from './SignupContainer';

import { MessageProvider } from '../Common/Message';

ReactDOM.render(
	<React.StrictMode>
		<MessageProvider>
			<SignupContainer />
		</MessageProvider>
	</React.StrictMode>,
	document.querySelector('#component-signup')
);
